import React from 'react';
import { FaFacebook, FaInstagram, FaWhatsapp, FaLinkedin } from 'react-icons/fa';
import { Facebook, Instagram, Sparkles, Moon, MessageCircle, Lock, Mail, Send, ArrowRight } from 'lucide-react';

const Footer = () => {
    return (
        <footer className="mt-auto bg-gray-800 text-white py-4 mt-8 sticky">
            <div className="container mx-auto flex flex-col items-center space-y-4 md:flex-row md:justify-between md:space-y-0">
                {/* Social Icons */}
                <div className="flex space-x-4">
                    <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                        <FaFacebook className="text-2xl hover:text-blue-500 transition-colors" />
                    </a>
                    <a href="https://www.instagram.com/dream.arium/" target="_blank" rel="noopener noreferrer">
                        <FaInstagram className="text-2xl hover:text-pink-500 transition-colors" />
                    </a>
                    <a href="https://www.linkedin.com/company/dreamariumpage/" target="_blank" rel="noopener noreferrer">
                        <FaLinkedin className="text-2xl hover:text-blue-500 transition-colors" />
                    </a>
                    {/* <a href="https://wa.me" target="_blank" rel="noopener noreferrer">
                        <FaWhatsapp className="text-2xl hover:text-green-500 transition-colors" />
                    </a> */}
                </div>
                
                {/* Footer Text */}
                <p className="text-center text-sm md:text-left">
                Dreamarium © {new Date().getFullYear()} - All rights reserved.
                </p>
                {/* <div className="flex gap-4">
              <a href="#" className="hover:text-purple-400 transition-colors duration-300">
                <Instagram size={24} />
              </a>
              <a href="#" className="hover:text-purple-400 transition-colors duration-300">
                <Facebook size={24} />
              </a>
            </div> */}
            </div>
        </footer>
    );
};

export default Footer;
